import { BookingDetails, GvPrimaryButton, Loading, PetAvatars } from "../../../components";
import React, { useEffect, useState } from "react";

import { CloseIcon } from "../../../components/Icons";
import GvSecondaryButton from "../../../components/GvSecondaryButton/GvSecondaryButton";
import { MODALS } from "../../../config/params";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { useApppointmentDetail } from "../../../services/appointment-detail/appointment-detail.service";
import { useModal } from "../../../context/ModalContext";

const RescheduleVisitConfirmationModal = () => {
  const { closeModal, openModal } = useModal();
  const [contactApplication, setContactApplication] = useState<string>("");
  const { selectedVisit } = useAppointmentStore();
  const { getAppointment, appointment, loading } = useApppointmentDetail();

  useEffect(()=>{
    if (selectedVisit) {
      getAppointment(selectedVisit?.id);
    }
  }, [selectedVisit]);

  useEffect(() => {
    if (appointment) {
      if (/iPad|iPhone|iPod|Mac/.test(navigator.userAgent)) {
        setContactApplication(`facetime:${appointment.location.phoneNumber}`);
      } else {
        setContactApplication(`tel:${appointment.location.phoneNumber}`);
      }
    }
  }, [appointment]);


  const locationImage = "/assets/icons/uptown.jpg";

  const handleCancelClick = () => {
    openModal(MODALS.VISIT_CANCEL);
  };

  const handleRescheduleClick = () =>{
    openModal(MODALS.RESCHEDULE_A_VISIT);
  };

  if (loading) {
    return <Loading centerAll={true} />;
  }

  return (
    <div className="h-full ">
      <div className="h-[25%]">
        <div className="h-full mt-[-1.01rem] mx-[-1.05rem]">
          <img className="w-full rounded-t-3xl  object-cover h-full" src={locationImage} alt="Uptown" />
        </div>
        <div className="absolute top-1 right-1 p-2 text-white cursor-pointer" onClick={closeModal}>
          <CloseIcon />
        </div>
      </div>
      {appointment && (
        <div className="h-[60%] py-4  ">
          <div className=" w-full flex flex-col h-[30%] grow shrink justify-center
          items-center  relative top-[-11%] ">
            <PetAvatars petDetails={[appointment.pet]} />
            <div className="flex flex-col justify-center items-center">
              <span className="grenette-light-pro text-2xl">Woohoo!</span>
              <span className="text-sm text-gray-1">Your visit is all set </span>
            </div>
          </div>
          <div className="flex grow shrink h-[70%] overflow-y-auto scroll-hide w-full justify-center">
            <BookingDetails
              location={appointment.location}
              reasonsForVisit={appointment?.reasonsForVisit?.split(",")}
              end_at={appointment.end_at}
              start_at={appointment.start_at}
              appointmentType={appointment.appointmentType}
              appointment={appointment}
              initiation="bookingDetails"
              hospitalContact={contactApplication}
            />
          </div>

        </div>
      )}
      <div className="!sticky bottom-0">
        <GvPrimaryButton
          type="submit"
          className="!font-bold !capitalize"
          onClick={handleRescheduleClick}
        >
            Reschedule Visit
        </GvPrimaryButton>
        <GvSecondaryButton
          type='button'
          className="!font-bold !capitalize"
          onClick={handleCancelClick}
        >
            Cancel Visit
        </GvSecondaryButton>
      </div>
    </div>

  );
};

export default RescheduleVisitConfirmationModal;
